<template>
  <div>
    <page-toolbar>
      <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
    </page-toolbar>
    <kendo-grid
      ref="grid"
      :height="'calc(100vh - 332px)'"
      :dataSource="dataSource"
      :editable="'inline'"
      :filterable="true"
      :sortable="true"
      :pageable="true"
      :pageable-always-visible="true"
      :columns="columns"
    >
    </kendo-grid>
  </div>
</template>
<script>
import PageToolbar from '@/components/PageToolbar'
import {mapGetters} from 'vuex'
import {checkboxColumn} from '@/helpers/kendo-editors'
export default {
  name: 'ContactListLog',
  model: {prop: 'refresh', event: 'input'},
  props: {
    refresh: {type: Boolean, required: true},
    asOfDate: {type: String, required: false},
  },
  data() {
    return {
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 10,
        transport: {
          read: {
            type: 'GET',
            url: '/api/report/monthlyReportSendingList/getLogDataSource',
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/report/monthlyReportSendingList/createStarContact',
            dataType: 'json',
            data: () => ({
              reportDate: this.asOfDate,
            }),
            complete: () => {
              this.gridRefresh()
            },
          },
          destroy: {
            type: 'DELETE',
            url: '/api/report/monthlyReportSendingList/deleteStarContact',
            dataType: 'json',
            complete: () => {
              this.gridRefresh()
            },
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'contactListLogId',
            fields: {
              contactListLogId: {type: 'number', defaultValue: 0},
              message: {type: 'string', editable: false},
              email: {type: 'string', editable: false},
              clientName: {type: 'string', editable: false},
              firstName: {type: 'string', editable: false},
              lastName: {type: 'string', editable: false},
              triggerAdd: {type: 'bool', editable: true},
              disableAdd: {type: 'bool', editable: false},
              canDelete: {type: 'bool', editable: false},
              monthlyReportEmailId: {type: 'number'},
            },
          },
        },
      }),
      columns: [
        checkboxColumn(
          'triggerAdd',
          {title: 'Create Contact', width: 25, hideByDefault: true},
          false,
          null,
          function(dataItem) {
            return dataItem.disableAdd
          },
        ),
        {field: 'message', title: 'Message', width: 100, attributes: {style: 'text-align:left'}},
        {field: 'email', title: 'Email', width: 80, attributes: {style: 'text-align:left'}},
        {field: 'clientName', title: 'Client', width: 100, attributes: {style: 'text-align:left'}},
        {
          field: 'firstName',
          title: 'First Name',
          width: 50,
          attributes: {style: 'text-align:left'},
        },
        {field: 'lastName', title: 'Last Name', width: 50, attributes: {style: 'text-align:left'}},
        {
          command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
          width: 15,
        },
      ],
    }
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },
  watch: {
    refresh: function() {
      this.gridRefresh()
    },
  },
  methods: {
    gridRefresh() {
      const grid = this.$refs.grid.kendoWidget()
      grid.dataSource.read()
      grid.dataSource.page(1)
      grid.refresh()
    },
    exportToExcel() {
      window.location.href = `/api/report/monthlyReportSendingList/exportLogToExcel?t=${
        this.tokenString
      }`
    },
  },
  components: {
    PageToolbar,
  },
}
</script>
